import { AgChartOptions, AgSankeySeriesOptions } from 'ag-charts-enterprise';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDashboardValidationQuery } from '../../hooks/queries/useDashboardQuery';
import GenericAgChart from './GenericAgChart';

interface ValidationSankeyChartProps {
    today: string;
}

const ValidationSankeyChart: React.FC<ValidationSankeyChartProps> = ({ today }) => {
    const { t } = useTranslation();

    const { data: dataValidation } = useDashboardValidationQuery({ date: today });

    console.log(dataValidation);

    const options: AgChartOptions = {
        data: (
            dataValidation?.flatMap((item) => [
                {
                    source: item.conduc?.username || 'Sans conduc',
                    target: 'En validation',
                    value: item.nbActivitiesInValidation,
                    id: item.conducId,
                },
                {
                    source: item.conduc?.username || 'Sans conduc',
                    target: 'Validées',
                    value: item.nbActivitiesValidated,
                    id: item.conducId,
                },
            ]) || []
        ).concat(
            {
                id: 'total',
                source: 'En validation',
                target: 'Total',
                value: dataValidation?.reduce((acc, item) => acc + item.nbActivitiesInValidation, 0) || 0,
            },
            {
                id: 'total',
                source: 'Validées',
                target: 'Total',
                value: dataValidation?.reduce((acc, item) => acc + item.nbActivitiesValidated, 0) || 0,
            }
        ),
        padding: { top: 0, right: 0, bottom: 0, left: 0 },
        zoom: {
            enabled: false,
        },
        series: [
            {
                type: 'sankey',
                fromKey: 'source',
                toKey: 'target',
                sizeKey: 'value',
                label: {
                    edgePlacement: 'inside',
                },
                node: {
                    width: 40,
                    strokeWidth: 1,
                    strokeOpacity: 0.6,
                },
            } as AgSankeySeriesOptions,
        ],
    };

    return <GenericAgChart options={options} />;
};

export default ValidationSankeyChart;
